import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Phone, Email, LocationOn } from '@mui/icons-material';
import WechatIcon from '@mui/icons-material/ChatBubble';
import RedNoteIcon from '@mui/icons-material/Book';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 6, mt: 'auto' }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t('footer.title')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <LocationOn sx={{ mr: 1 }} />
              <Typography variant="body2">
                {t('footer.address')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t('footer.contact.title')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Phone sx={{ mr: 1 }} />
              <Typography variant="body2">
                {t('footer.contact.phone')}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Email sx={{ mr: 1 }} />
              <Typography variant="body2">
                {t('footer.contact.email')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t('footer.social.title')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <IconButton color="inherit" size="small" sx={{ mr: 1 }}>
                <WechatIcon />
              </IconButton>
              <Typography variant="body2">
                {t('footer.social.wechat')}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton color="inherit" size="small" sx={{ mr: 1 }}>
                <RedNoteIcon />
              </IconButton>
              <Typography variant="body2">
                {t('footer.social.rednote')}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Typography variant="body2" align="center" sx={{ mt: 4 }}>
          © {new Date().getFullYear()} {t('footer.copyright')}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;